import React from 'react';

import CPQuoteWinterList  from 'components/Tvendo/Sale/QuotaBPartner/Winter/QuotaCustomer/List.js';

export default function () {
  return <CPQuoteWinterList  />;
}